var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.items,"menu-props":{ maxHeight: '400' },"label":_vm.label,"hint":"FAIR Form of Loss Category","clearable":"","chips":""},model:{value:(_vm.incidentCostTypeCategories),callback:function ($$v) {_vm.incidentCostTypeCategories=$$v},expression:"incidentCostTypeCategories"}})
}
var staticRenderFns = []

export { render, staticRenderFns }